export default __webpack_public_path__ + "static/media/ash.6ad6a21b.png";